var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCouponsidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z",
    fill: "#9197B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 9.375C5.625 8.13236 6.63236 7.125 7.875 7.125H16.125C17.3676 7.125 18.375 8.13236 18.375 9.375V9.5625C18.375 9.87316 18.1232 10.125 17.8125 10.125V10.125C16.8805 10.125 16.125 10.8805 16.125 11.8125V12.1875C16.125 13.1195 16.8805 13.875 17.8125 13.875V13.875C18.1232 13.875 18.375 14.1268 18.375 14.4375V14.625C18.375 15.8676 17.3676 16.875 16.125 16.875H7.875C6.63236 16.875 5.625 15.8676 5.625 14.625V14.4375C5.625 14.1268 5.87684 13.875 6.1875 13.875V13.875C7.11948 13.875 7.875 13.1195 7.875 12.1875V11.8125C7.875 10.8805 7.11948 10.125 6.1875 10.125V10.125C5.87684 10.125 5.625 9.87316 5.625 9.5625V9.375Z",
    stroke: "#9197B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.84712L12.5948 10.6606C12.7182 10.8294 12.8914 10.9552 13.0901 11.0204L14.0475 11.3347L13.4577 12.1517C13.3353 12.3213 13.2691 12.5249 13.2685 12.734L13.2654 13.7417L12.3061 13.4332C12.1071 13.3692 11.8929 13.3692 11.6939 13.4332L10.7346 13.7417L10.7315 12.734C10.7309 12.5249 10.6647 12.3213 10.5423 12.1517L9.95249 11.3347L10.9099 11.0204C11.1086 10.9552 11.2818 10.8294 11.4052 10.6606L12 9.84712Z",
    stroke: "#9197B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponsidebar);
export default __webpack_public_path__ + "static/media/couponsidebar.761aa3565ddb6142b0a3eb06aab809ac.svg";
export { ForwardRef as ReactComponent };